export default "__VITE_ASSET__e974dbbc__"